import { Component, h, Node, WriteOnlyRef } from "@lukekaalim/act";
import { html } from "@lukekaalim/act-web";

import classes from './index.module.css';
import { ProfileCapsuleMenu } from "../ProfileCapsuleMenu";
import { Account, AccountDescription } from "../../defs";
import { AuthState } from "../../hooks";

export type ProfileOverlayProps = {
  auth: AuthState,
  account: AccountDescription | null,

  profileCircleRef?: WriteOnlyRef<HTMLElement>,
  beforeCapsule?: Node,
}

export const ProfileOverlay: Component<ProfileOverlayProps> = ({ auth, account, profileCircleRef, beforeCapsule = null }) => {
  return h(html.div, { className: classes.profileOverlayCorner }, [
    beforeCapsule,
    h(ProfileCapsuleMenu, { account, profileCircleRef, auth })
  ]);
}